<script>
import Popper from "popper.js";

export default {
    name: "popper",
    props: {
        config: {
            type: Object,
            default: () => ({ placement: "bottom" })
        },
        disabled: Boolean
    },
    data() {
        return {
            isOpen: false,
            triggerEl: null,
            popperEl: null
        };
    },
    beforeDestroy() {
        if (!this.popper) {
            return;
        }
        this.popper.destroy();
    },
    mounted() {
        this.triggerEl = this.$el.querySelector("[data-trigger]");
        this.popperEl = this.$el.querySelector("[data-popper]");
    },
    methods: {
        open() {
            if (this.isOpen) {
                return;
            }

            this.isOpen = true;
            this.$nextTick(() => {
                this.setupPopper();
            });
        },
        close() {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
        },
        setupPopper() {
            if (this.popper === undefined) {
                this.popper = new Popper(this.triggerEl, this.popperEl, this.config);
            }
            else {
                this.popper.scheduleUpdate();
            }
        }
    },
    watch: {
        isOpen() {
            this.$emit('isOpen', this.isOpen)
        }
    },
    render() {
        return this.$scopedSlots.default({
            isOpen: this.isOpen,
            open: this.open,
            close: this.close
        });
    }
}
</script>